'use client';

import { useEffect } from 'react';
import { installGlobalErrorHandlers } from '@/lib/error-reporting';

/**
 * Installs window-level error + unhandledrejection listeners for the whole app.
 * Rendered once from the root layout; renders nothing.
 */
export default function GlobalErrorHandlers() {
  useEffect(() => {
    installGlobalErrorHandlers();
  }, []);
  return null;
}
